function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }

function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

/**
 * Array module.
 * @module src/array
 */
import { isBlank } from './any';
import { isFunction } from './function';
/**
 * Returns the array cut in 2 parts in the position.
 *
 * @function cut
 *
 * @param {any[]} list - the list to be cut.
 * @param {integer} position - the position to cut the array.
 * @return {array} an array containing 2 arrays with the parts cut.
 *
 * @example
 * cut(['a', 'b', 'c'], 0);
 * // returns [[], ['a', 'b', 'c']]
 *
 * @example
 * cut(['a', 'b', 'c'], 1);
 * // returns [['a'], ['b', 'c']]
 *
 * @example
 * cut(['a', 'b', 'c'], 2);
 * // returns [['a', 'b'], ['c']]
 *
 * @example
 * cut(['a', 'b', 'c'], 3);
 * // returns [['a', 'b', 'c'], []]
 *
 * @example
 * cut(['a', 'b', 'c'], 4);
 * // returns [['a', 'b', 'c'], []]
 *
 */

export const cut = (list, position) => {
  if (position < 0) throw new Error(`the position ${position} must be zero or a positive number`);
  return [list.slice(0, position), list.slice(position, list.length)];
};
/**
 * Returns if an array is empty or not
 *
 * @function isEmptyArray
 *
 * @param {any[]} array - the array to be checked.
 * @return {boolean} if the array is empty or not.
 *
* @example
 * isEmptyArray('');
 * // returns false
 *
* @example
 * isEmptyArray([null]);
 * // returns false
 *
* @example
 * isEmptyArray([]);
 * // returns true
 *
 */

export const isEmptyArray = array => Array.isArray(array) && array.length === 0;
/**
 * Returns an object grouping the array by given criteria function
 *
 * @function groupBy
 *
 * @param {array} array - the array to be grouped.
 * @param {function} groupCriteria - the function to define how to group the elements.
 * @return {object} the grouped array.
 *
 * @example
 * groupBy([], element => isEven(element) ? 'even' : 'odd')
 * // returns {}
 *
 * @example
 * groupBy([1, 2, 3], 'some thing')
 * // returns { all: [1, 2, 3] }
 *
 * @example
 * groupBy([1, 2, 3], element => isEven(element) ? 'even' : 'odd')
 * // returns { odd: [1], even: [2, 3] }
 *
 */

export const groupBy = (array, groupCriteria) => {
  if (isBlank(array)) return {};
  if (!isFunction(groupCriteria)) return {
    all: array
  };
  const groups = {};
  array.forEach(element => {
    const criteria = groupCriteria(element);
    if (!(criteria in groups)) groups[criteria] = [];
    groups[criteria].push(element);
  });
  return groups;
};
/**
 * Returns other array sorted by the given criteria function
 *
 * @function sortBy
 *
 * @param {array} array - the array to be sorted.
 * @param {function} sortCriteria - the function to define how to sort the elements.
 * @return {array} the sorted array.
 *
 * @example
 * sortBy([], person => person.age)
 * // returns []
 *
 * @example
 * sortBy([4, 2, 3], number => number)
 * // returns [2, 3, 4]
 *
 * @example
 * sortBy([{ name: 'Batista', age: 31 }, { name: 'Jimmy', age: 23 }], person => person.age)
 * // returns [{ name: 'Jimmy', age: 23 }, { name: 'Batista', age: 31 }]
 *
 */

export const sortBy = (array, sortCriteria) => {
  if (!Array.isArray(array)) throw new Error(`Was expected '${array}' to be an Array.`);
  if (!isFunction(sortCriteria)) throw new Error('The argument sortCriteria must be a function.');
  const arrayCopy = array.slice();
  arrayCopy.sort((firstElement, secondElement) => {
    const firstSortCriteria = sortCriteria(firstElement);
    const secondSortCriteria = sortCriteria(secondElement);
    if (firstSortCriteria === secondSortCriteria) return 0;
    if (firstSortCriteria > secondSortCriteria) return 1;
    return -1;
  });
  return arrayCopy;
};
/**
 * Returns the min and max elements of an array based on a sort criteria
 *
 * @function minMaxBy
 *
 * @param {Array} array - the array to get the elements.
 * @param {Function} sortCriteria - the function to define how to sort the elements.
 * @return {Array} an array including the min and max elements of the array.
 *
 * @example
 * minMaxBy([], person => person.age)
 * // returns [null, null]
 *
 *
 * @example
 * minMaxBy([{ name: 'Batista', age: 31 }, { name: 'Guilherme', age: 25 }, { name: 'Jimmy', age: 23 }], person => person.age)
 * // returns [{ name: 'Jimmy', age: 23 }, { name: 'Batista', age: 31 }]
 *
 */

export const minMaxBy = (array, sortCriteria) => {
  if (isBlank(array)) return [null, null];
  const sortedArray = sortBy(array, sortCriteria);
  return [sortedArray[0], sortedArray[sortedArray.length - 1]];
};
/**
 * Returns the min element of an array based on a sort criteria
 *
 * @function minBy
 *
 * @param {Array} array - the array to get the elements.
 * @param {Function} sortCriteria - the function to define how to sort the elements.
 * @return {Any} an element representing the min value based on sort criteria.
 *
 * @example
 * minBy([], person => person.age)
 * // returns null
 *
 *
 * @example
 * minBy([{ name: 'Batista', age: 31 }, { name: 'Guilherme', age: 25 }, { name: 'Jimmy', age: 23 }], person => person.age)
 * // returns { name: 'Jimmy', age: 23 }
 *
 */

export const minBy = (array, sortCriteria) => {
  const _minMaxBy = minMaxBy(array, sortCriteria),
        _minMaxBy2 = _slicedToArray(_minMaxBy, 1),
        min = _minMaxBy2[0];

  return min;
};
/**
 * Returns the max element of an array based on a sort criteria
 *
 * @function maxBy
 *
 * @param {Array} array - the array to get the elements.
 * @param {Function} sortCriteria - the function to define how to sort the elements.
 * @return {Any} an element representing the max value based on sort criteria.
 *
 * @example
 * maxBy([], person => person.age)
 * // returns null
 *
 *
 * @example
 * maxBy([{ name: 'Batista', age: 31 }, { name: 'Guilherme', age: 25 }, { name: 'Jimmy', age: 23 }], person => person.age)
 * // returns { name: 'Batista', age: 31 }
 *
 */

export const maxBy = (array, sortCriteria) => {
  const _minMaxBy3 = minMaxBy(array, sortCriteria),
        _minMaxBy4 = _slicedToArray(_minMaxBy3, 2),
        max = _minMaxBy4[1];

  return max;
};
/**
 * Returns the min and max elements of an array based on the whole element
 *
 * @function minMax
 *
 * @param {Array} array - the array to get the elements.
 * @return {Array} an array including the min and max elements of the array.
 *
 * @example
 * minMax([])
 * // returns [null, null]
 *
 *
 * @example
 * minMax(['Bruno', 'Alexandre', 'Eurico', 'Pedro', 'Batista'])
 * // returns ['Alexandre', 'Pedro']
 *
 */

export const minMax = array => minMaxBy(array, element => element);
/**
 * Returns the min element of an array based on the whole element
 *
 * @function min
 *
 * @param {Array} array - the array to get the elements.
 * @return {Array} an array including the min element of the array.
 *
 * @example
 * min([])
 * // returns null
 *
 *
 * @example
 * min(['Bruno', 'Alexandre', 'Eurico', 'Pedro', 'Batista'])
 * // returns 'Alexandre'
 *
 */

export const min = array => minBy(array, element => element);
/**
 * Returns the max element of an array based on the whole element
 *
 * @function max
 *
 * @param {Array} array - the array to get the elements.
 * @return {Array} an array including the max element of the array.
 *
 * @example
 * max([])
 * // returns null
 *
 *
 * @example
 * max(['Bruno', 'Alexandre', 'Eurico', 'Pedro', 'Batista'])
 * // returns 'Pedro'
 *
 */

export const max = array => maxBy(array, element => element);
/**
 * Returns other array with repeated items removed
 *
 * @function uniq
 *
 * @param {array} array - the array to be unified.
 * @return {array} the unified array.
 *
 * @example
 * uniq([])
 * // returns []
 *
 * @example
 * uniq([4, null, null, 2, ['a', 'b'], 3, ['a', 'b'], ['b', 'a']])
 * // returns [4, null, 2, ['a', 'b'], 3, ['b', 'a']]
 *
 */

export const uniq = array => uniqBy(array, element => element);
/**
 * Returns other array with repeated items removed based on a criteria function
 *
 * @function uniqBy
 *
 * @param {array} array - the array to be removed.
 * @param {function} uniqCriteria - the function to define how to sort the elements.
 * @return {array} the unified array.
 *
 * @example
 * uniqBy([], user => user.id)
 * // returns []
 *
 * @example
 * uniq([{ id: 1, name: 'Bruno' }, { id: 2, name: 'André' }, { id: 1, name: 'Bruno Vicenzo' }, { id: 3, name: 'Eurico' }])
 * // returns [{ id: 1, name: 'Bruno' }, { id: 2, name: 'André' }, { id: 3, name: 'Eurico' }]
 *
 */

export const uniqBy = (array, uniqCriteria) => {
  const toJSON = element => JSON.stringify(element);

  const isFirstOccurrence = (element, currentIndex, self) => {
    return self.findIndex(otherElement => toJSON(uniqCriteria(otherElement)) === toJSON(uniqCriteria(element))) === currentIndex;
  };

  return array.filter(isFirstOccurrence);
};